import { useMemo } from 'react'
import useGetFeatureFlag from '../../domain/useGetFeatureFlag'
import { getUserEmail } from '../../common/helper'
import useUserType from '../../domain/useUserType'
import { getCurrentBpId, getExternalBpId } from '../../common/helper'

const useFeatureFlagState = (flagName: string) => {
  const loggedInUserEmail = getUserEmail()
  const { data: userTypeResponse, isLoading: isUserTypeLoading } = useUserType()
  const user_type = userTypeResponse?.user_type ?? ''

  const isQueryEnabled = !!(loggedInUserEmail && user_type)

  const { data, isLoading, isError, fetchStatus } = useGetFeatureFlag(
    flagName,
    {
      user_email_id: loggedInUserEmail,
      user_type: user_type,
      bp_id: user_type === 'INTERNAL' ? getCurrentBpId() : getExternalBpId(),
    },
    isQueryEnabled,
  )

  const isEnabled = useMemo(() => {
    if (isError || data === undefined) {
      return false
    }
    return data ?? false
  }, [data, isError])

  const isFlagLoading = useMemo(() => {
    if (isUserTypeLoading) {
      return true
    }
    if (!isQueryEnabled) {
      return false
    }
    return isLoading && fetchStatus !== 'idle'
  }, [isUserTypeLoading, isQueryEnabled, isLoading, fetchStatus])

  return { isEnabled, isLoading: isFlagLoading }
}

export default useFeatureFlagState
